/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { RestoreClusterDataForm } from './RestoreClusterDialog.types';

export const restoreClusterInitialValues: RestoreClusterDataForm = {
  backupMinTimestamp: new Date('1900-01-01'),
  backupMaxTimestamp: new Date('2099-12-31'),
  backupTimestamp: new Date(),
  backupName: '',
};

export const restoreClusterValidationSchema = Yup.object({
  backupMinTimestamp: Yup.date(),
  backupMaxTimestamp: Yup.date(),
  backupTimestamp: Yup.date()
    .nullable()
    .notOneOf([undefined], 'invalid_date')
    .required('empty')
    .min(Yup.ref('backupMinTimestamp'), 'before_min_date')
    .max(Yup.ref('backupMaxTimestamp'), 'after_max_date'),
  backupName: Yup.string(),
});
